import { useCallback, useEffect, useRef, useState } from "react";
import { api } from "../lib/api";
export function useWordStoreUpdates(enabled: boolean, accountId?: string) {
  const [count, setCount] = useState(0);
  const active = useRef<AbortController | null>(null);
  const refresh = useCallback(() => {
    if (!enabled || document.visibilityState === "hidden") return;
    active.current?.abort(); const controller = new AbortController(); active.current = controller;
    void api<{ count: number }>("/word-store/unread", { signal: controller.signal }).then((result) => { if (!controller.signal.aborted) setCount(result.count); }).catch(() => { if (!controller.signal.aborted) setCount(0); });
  }, [enabled, accountId]);
  useEffect(() => { setCount(0); refresh(); if (!enabled) { active.current?.abort(); return; } const timer = window.setInterval(refresh, 60000); window.addEventListener("focus", refresh); document.addEventListener("visibilitychange", refresh); return () => { active.current?.abort(); clearInterval(timer); window.removeEventListener("focus", refresh); document.removeEventListener("visibilitychange", refresh); }; }, [refresh, enabled]);
  return { count, refresh };
}
